import axiosInstance from "./axios-instance";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const getWorkroomSetting = async (payload: { id?: number, type?: number, accountId?: number }) => {
    try {
        const response = await axiosInstance.post<any>(
            "/workroomSetting/get",
            payload
        );

        return response.data;
    } catch (error) {
        console.error("Error while getting workroom setting:", error);
        throw error;
    }
};

const searchWorkroomSetting = async (accountId: number, type?: number) => {
    try {
        const scopedAccountId = getScopedAccountId(accountId);
        const response = await axiosInstance.post<any>(
            "/workroomSetting/search",
            { accountId: scopedAccountId, type }
        );
        return response.data;
    } catch (error) {
        console.error("Error while getting workroom setting:", error);
        throw error;
    }
};

const addWorkroomSetting = async (payload: any) => {
    try {
        const response = await axiosInstance.post<any>("/workroomSetting/add", {
            ...payload,
        });
        return response.data;
    } catch (error) {
        console.error("Error while creating workroom setting:", error);
        throw error;
    }
};

const editWorkroomSetting = async (payload: any) => {
    try {
        const response = await axiosInstance.post<any>(
            "/workroomSetting/update",
            payload
        );

        return response.data;
    } catch (error) {
        console.error("Error while updating workroom setting:", error);
        throw error;
    }
};

export {
    getWorkroomSetting,
    searchWorkroomSetting,
    addWorkroomSetting,
    editWorkroomSetting,
};
